import React, { useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { useTranslate } from '@im/react-localization';

export interface SearchOption {
  id: number;
  label: string;
}

export { Autocomplete, InputAdornment, IconButton, SearchIcon, TextField };

export interface SearchBarWithChipsInsideInputProps {
  searchOptions: SearchOption[];
  selectedOptions: SearchOption[];
  setGroupName: React.Dispatch<React.SetStateAction<string>>;
  setSelectedOptions: (options: SearchOption[]) => void;
  testId: string;
}

const SearchBarWithChipsInsideInput: React.FC<
  SearchBarWithChipsInsideInputProps
> = ({
  searchOptions,
  selectedOptions,
  setGroupName,
  setSelectedOptions,
  testId,
}) => {
  const translate = useTranslate();
  const [inputValue, setInputValue] = useState('');
  useEffect(() => {
    setGroupName(inputValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue]);
  return (
    <Autocomplete
      filterSelectedOptions
      getOptionLabel={(option) => option.label}
      inputValue={inputValue}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      limitTags={2}
      multiple
      onChange={(event, newValue) => {
        setSelectedOptions(newValue);
        setInputValue('');
      }}
      onInputChange={(event, inputValue, reason) => {
        if (reason === 'input') {
          setInputValue(inputValue);
        }
      }}
      options={searchOptions}
      renderInput={(params) => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                <InputAdornment position="start">
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
                {params.InputProps.startAdornment}
              </>
            ),
          }}
          inputProps={{
            ...params.inputProps,
            'data-testid': `${testId}-search-bar-with-chips-input`,
          }}
          placeholder={translate('Common.Search')}
          variant="outlined"
        />
      )}
      sx={{
        '& .MuiAutocomplete-inputRoot': {
          display: 'flex',
          flexWrap: 'wrap',
        },
        '.MuiAutocomplete-tag': {
          height: '26px !important',
        },
        minWidth: 300,
      }}
      value={selectedOptions}
    />
  );
};

export default SearchBarWithChipsInsideInput;
